import { useCallback, useEffect, useState } from 'react';
import useLinkedStudiesApi from '../../api/requests/useLinkedStudiesApi';

const useLinkedSubmissions = (requestId, enabled = true) => {
  const { getLinkedSubmissions } = useLinkedStudiesApi();
  const [data, setData] = useState({ data: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  const fetchSubmissions = useCallback(async () => {
    if (!requestId || !enabled) return;

    console.log({
      requestId,
      enabled,
    });

    setLoading(true);
    try {
      setData(await getLinkedSubmissions(requestId, { page, limit: 20 }));
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to load linked submissions');
    } finally {
      setLoading(false);
    }
  }, [requestId, enabled, page, getLinkedSubmissions]);

  useEffect(() => {
    fetchSubmissions();
  }, [fetchSubmissions]);
  return { ...data, loading, error, page, setPage, refetch: fetchSubmissions };
};

export default useLinkedSubmissions;
